/* import __COLOCATED_TEMPLATE__ from './table-opportunities-keyword-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();